import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getParents' })
export class GetParentsPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
